import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/home/logo.png';
import _imports_1 from '@/assets/img/home/menu.png';
import _imports_2 from '@/assets/img/home/close.png';
const _withScopeId = n => (_pushScopeId("data-v-78476d72"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top_box"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  style: {
    "padding-right": "30px"
  },
  alt: ""
}, null, -1));
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "免费试用", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "icon",
  style: {
    "flex": "1",
    "text-align": "right"
  }
};
const _hoisted_8 = {
  key: 0,
  class: "menu"
};
const _hoisted_9 = ["onClick"];
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { isMobile } from "@/utils/isMobile";
export default /*#__PURE__*/_defineComponent({
  __name: 'Top',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    // const textArr = ["首页", "产品", "客户及案例", "关于我们"];
    const textArr = ["首页", "AI拓客", '智悦拎包', '智悦节能', '合伙人招募', "联系我们"];
    !isMobile() && textArr.splice(4, 0, "获客学院");
    const active = ref(0);
    const boxShow = ref(false);
    const menuShow = ref(false);
    const childShow = ref(true);
    const change = i => {
      if (i !== 1) {
        active.value = i;
      }
      menuShow.value = false;
      if (isMobile()) {
        switch (i) {
          case 0:
            router.push({
              name: "home"
            });
            break;
          case 1:
            router.push({
              name: "marketing"
            });
            break;
          case 2:
            router.push({
              name: "package"
            });
            break;
          case 3:
            router.push({
              name: "energy"
            });
            break;
          case 4:
            router.push({
              name: "partner"
            });
            break;
          case 5:
            router.push({
              name: "about"
            });
            break;
          case 7:
            router.push({
              name: "login"
            });
            break;
          default:
            break;
        }
      } else {
        switch (i) {
          case 0:
            router.push({
              name: "home"
            });
            break;
          case 1:
            router.push({
              name: "marketing"
            });
            break;
          case 2:
            router.push({
              name: "package"
            });
            break;
          case 3:
            router.push({
              name: "energy"
            });
            break;
          case 4:
            router.push({
              name: "zixun"
            });
            break;
          case 5:
            router.push({
              name: "partner"
            });
            break;
          case 6:
            router.push({
              name: "about"
            });
            break;
          case 7:
            router.push({
              name: "login"
            });
            break;
          default:
            break;
        }
      }
    };
    const clickAway = () => {
      boxShow.value = false;
    };
    //监听路由变化改变 active
    watch(() => route.name, () => {
      if (isMobile()) {
        switch (route.name) {
          case 'home':
            active.value = 0;
            break;
          case 'marketing':
            active.value = 1;
            break;
          case 'package':
            active.value = 2;
            break;
          case 'energy':
            active.value = 3;
            break;
          // case 'case':
          //   active.value = 4;
          //   break;
          case 'partner':
            active.value = 4;
            break;
          case 'about':
            active.value = 5;
            break;
        }
      } else {
        switch (route.name) {
          case 'home':
            active.value = 0;
            break;
          case 'marketing':
            active.value = 1;
            break;
          case 'package':
            active.value = 2;
            break;
          case 'energy':
            active.value = 3;
            break;
          case 'zixun':
            active.value = 4;
            break;
          case 'zixunDetail':
            active.value = 4;
            break;
          case 'partner':
            active.value = 5;
            break;
          case 'about':
            active.value = 6;
            break;
        }
      }
    });
    return (_ctx, _cache) => {
      const _directive_click_away = _resolveDirective("click-away");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(textArr, (item, i) => {
        return _createElementVNode("div", {
          class: _normalizeClass(['text', 'hidden-xs-only', active.value === i ? 'active' : ''])
        }, [_createElementVNode("div", {
          onClick: $event => change(i)
        }, _toDisplayString(item), 9, _hoisted_4)], 2);
      }), 64)), _unref(route).name !== 'login' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "free",
        onClick: _cache[0] || (_cache[0] = $event => change(7))
      }, _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [!menuShow.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "hidden-sm-and-up",
        src: _imports_1,
        alt: "",
        onClick: _cache[1] || (_cache[1] = $event => menuShow.value = true)
      })) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "hidden-sm-and-up",
        src: _imports_2,
        alt: "",
        onClick: _cache[2] || (_cache[2] = $event => menuShow.value = false)
      }))])])), [[_directive_click_away, clickAway]]), _createVNode(_Transition, {
        name: "slide",
        "enter-active-class": "animate__animated animate__slideInDown",
        "leave-active-class": "animate__animated animate__slideOutUp"
      }, {
        default: _withCtx(() => [menuShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(textArr, (item, i) => {
          return _createElementVNode("div", {
            key: i,
            class: "menu_item",
            onClick: $event => change(i)
          }, _toDisplayString(item), 9, _hoisted_9);
        }), 64))])) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
});